<section class="home__block3 container-fluid px-2 px-sm-4">
      <div class="container g-0">
          <div class="block3__container">
              <div class="block__assets__container me-0 me-md-2">
                  <img
                      [src]="'images/alamo-standard-of-care-600.png' | cdn"
                      alt="standard of care icon"
                      class="block__image"
                    />
              </div>
              <div class="block__info__container">
                  <h3 class="block__info__titlte">
                      {{ 'fe_landing_standard_of_care_title' | translate }}
                  </h3>
                  <p class="block__info__txt">
                      {{ 'fe_landing_standard_of_care_text' | translate }}
                  </p>
                  <fe-button
                      [style]="'link2btn'"
                      [href]="'about-us-a/our-standard-of-care' | formatUrl"
                  >
                      {{ 'fe_landing_standard_of_care_button' | translate }}
                  </fe-button>
              </div>
          </div>
      </div>
</section>
